module.exports = __webpack_public_path__ + "static/media/ForexWorldWide_Logo_160x150.27ab27b5.png";